import React from "react";
import styled from "styled-components";
import { AmplitudeService } from "@analytics/Amplitude/AmplitudeService";
import CloseButton from "@common/LifeAtButton/Buttons/CloseButton";
import { CloseChat } from "../AmplitudeRoomChatEvents";
import { ChatContextType, useChatContext } from "../ChatContext";

const Header = styled.div`
    width: 100%;
    height: fit-content;

    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${(props) => props.theme.borderPrimary};
`;

const ChatHeader = styled.div`
    padding: 8px 20px;
`;

const StyledCloseButton = styled(CloseButton)`
    width: fit-content;

    * {
        background: none !important;
    }

    .lifeat-button {
        min-height: unset;
    }
`;

export default function RoomChatHeader() {
    const { setIsChatOpen }: ChatContextType = useChatContext();
    const amplitudeService = AmplitudeService.getInstance();

    const handleClose = () => {
        amplitudeService.logEvent(new CloseChat({ chatType: "room_chat" }));

        setIsChatOpen(false);
    };

    return (
        <Header>
            <ChatHeader>Chat</ChatHeader>
            <StyledCloseButton handleClose={handleClose} />
        </Header>
    );
}
